import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=ccc2529a&scoped=true"
import script from "./AdminMenu.vue?vue&type=script&lang=js"
export * from "./AdminMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminMenu.vue?vue&type=style&index=0&id=ccc2529a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc2529a",
  null
  
)

export default component.exports